import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
// import "./sidebarv2.css"
import "./../../Workspace-v2/sidebarv2.css";

// import Modal from "@mui/material/Modal";
import { GetAllProject, GetProject } from "../ApiServices/apiHandler";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory, useParams } from "react-router";
import { getProjects } from "../../../Console/Component/services/apiHandler";
import { useDispatch } from "react-redux";
import { fetchBSDataClean } from "../../../redux/actions/actionBS";



import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  bgcolor: "background.paper",
  outline: "none",
  borderRadius: "10px",
  p: 4,
};
const CompareFs = (props) => {
  const params = useParams()
  const history = useHistory();
  const dispatch = useDispatch();
  const { open, handleClose, w_id, allpreconsoldata } = props;
  const [allProject, setAllProject] = useState([]);
  const [selectPresetOpt1, setSelectPresetOpt1] = useState([]);
  const [selectPresetOpt2, setSelectPresetOpt2] = useState([]);
  const [dataId, setDataID] = useState({
    c1: "",
    c2: "",
  });

  useEffect(() => {
    AllProject();
  }, []);

  const AllProject = async () => {
    const res = await GetAllProject(params?.id)
    if (res.status === 200) {
      setAllProject(res.data.project);
    }
  };

  const handleChange = (e, field) => {

    setDataID({ ...dataId, [field]: e });
  };
  const nextCompare = () => {
    dispatch(fetchBSDataClean())
    history.push(`/comparefs/${dataId.c1}/${dataId.c2}`);
  };

  useEffect(() => {
    if (allProject.length > 0) {
      const preset1Opts = allProject.map((det) => ({
        label: det.project_name,
        value: det._id,
      }));
      setSelectPresetOpt1(preset1Opts);
    }

    if (allpreconsoldata.length > 0) {
      const preset2Opts = allpreconsoldata.map((det) => ({
        label: det.prepare_consol_company_name,
        value: det._id,
      }));
      setSelectPresetOpt2(preset2Opts);
    }
  }, [allProject, allpreconsoldata]);


  return (
    <>
      {open && (
        <Modal
          title="Select COA"
          bodycss={commoncss.unsetPadding}
          headerActions={
            <CloseIcon
              onClick={handleClose}
              className="clickable"
            />
          }
          onClose={() => console.log("Modal Closed")}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={handleClose}
                label="Export"
              />

              {dataId.c1 !== "" && dataId.c2 !== "" ? (
                <Button
                  btnColor={buttoncss.primary}
                  label="Compare"
                  onClick={() => nextCompare()}

                />
              ) : (
                <Button
                  btnColor={buttoncss.primary}
                  class_={buttoncss.disabledBtn}
                  label="Compare"
                  isEnabled={false}
                />
              )}

            </>
          }
        >
          <div className={commoncss.pd1530}>
            <Dropdown
              label="Select Preset 1"
              options={selectPresetOpt1}
              onSelect={(opt) => (handleChange(opt.value, "c1"))}
              placeHolder={"Select Preset 1"}
            />
            <Dropdown
              label="Select Preset 2"
              options={selectPresetOpt2}
              onSelect={(opt) => (handleChange(opt.value, "c2"))}
              placeHolder={"Select Preset 2"}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default CompareFs;
